import { Dispatch, SetStateAction, useState } from 'react'
import { TreeEventHandler, TreeNodeInfo } from '@blueprintjs/core'

interface TreeFunctions {
    handleNodeClick: any
    handleNodeCollapse: TreeEventHandler
    handleNodeExpand: TreeEventHandler
    nodes: TreeNodeInfo[]
    setNodes: Dispatch<SetStateAction<TreeNodeInfo[]>>
}

export const useTreeFunctions = (): TreeFunctions => {
    const [nodes, setNodes] = useState<TreeNodeInfo[]>([])

    const handleNodeClick: TreeEventHandler = (e, path, _) => {
        if (e.isExpanded) {
            handleNodeCollapse(e, path, _)
        } else {
            handleNodeExpand(e, path, _)
        }
    }

    const handleNodeCollapse: TreeEventHandler = (nodeData, path, _) => {
        nodeData.isExpanded = false
        // @ts-ignore
        nodes[path] = nodeData

        setNodes([...nodes])
    }

    const handleNodeExpand: TreeEventHandler = (nodeData, path, _) => {
        nodeData.isExpanded = true
        // @ts-ignore
        nodes[path] = nodeData

        setNodes([...nodes])
    }

    return {
        handleNodeClick,
        handleNodeCollapse,
        handleNodeExpand,
        nodes,
        setNodes,
    }
}
